import { Component, computed, input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import {
  getTaxDocumentFormNameKey,
  getTaxDocumentResidencySuffixKey,
  TAX_DOCUMENT_ORIGINAL_FORM_URLS
} from '../tax-documentation-contract.helpers';

@Component({
  selector: 'app-tax-documentation-w8ben-step',
  imports: [TranslatePipe, ReactiveFormsModule, KorviuInputComponent],
  templateUrl: './tax-documentation-w8ben-step.component.html',
  styleUrl: '../tax-documentation-modal.component.scss'
})
export class TaxDocumentationW8benStepComponent {
  readonly originalFormUrl = TAX_DOCUMENT_ORIGINAL_FORM_URLS.W8BEN;
  readonly formNameKey = getTaxDocumentFormNameKey('W8BEN');
  readonly residencySuffixKey = getTaxDocumentResidencySuffixKey('W8BEN');

  form = input.required<FormGroup>();

  fullNameControl = computed(() => this.getControl('fullName'));
  countryOfCitizenshipControl = computed(() => this.getControl('countryOfCitizenship'));
  permanentResidenceAddressControl = computed(() => this.getControl('permanentResidenceAddress'));
  permanentCityControl = computed(() => this.getControl('permanentCity'));
  permanentCountryControl = computed(() => this.getControl('permanentCountry'));
  sameMailingAddressControl = computed(() => this.getFormControl('sameMailingAddress'));
  mailingAddressControl = computed(() => this.getControl('mailingAddress'));
  mailingCityControl = computed(() => this.getControl('mailingCity'));
  mailingCountryControl = computed(() => this.getControl('mailingCountry'));
  foreignTaxIdNumberControl = computed(() => this.getControl('foreignTaxIdNumber'));

  get sameMailingAddress(): boolean {
    return !!this.sameMailingAddressControl().value;
  }

  private getControl(controlName: string): AbstractControl {
    return this.form().get(controlName);
  }

  private getFormControl(controlName: string): FormControl {
    return this.form().get(controlName) as FormControl;
  }
}
